import React/* , { useState, useEffect }  */from 'react';
import { NavLink/* , useNavigate */ } from 'react-router-dom';
import Shopping from '../components/images/iconstore/ShopW64.png';
import './checkoutbar.scss';

function CheckOutBar() {
    return (
        <div className="checkout-navbar-container">
            <div className="checkout-navbar">
                <div className="checkout-menu">
                    <NavLink className="checkout__navlink"
                        to="/negozioonline/checkout/ordinidiretti"
                        onClick={(e) => e.preventDefault()}
                        >
                        <p className="checkout__link">Consegna e fatturazione</p>
                    </NavLink>
                    <NavLink 
                        className="checkout__navlink" 
                        to="/negozioonline/checkout/ordinepagamento"
                        onClick={(e) => e.preventDefault()}
                        >
                        <p className="checkout__link">Ordine e Pagamento</p>
                    </NavLink>
                </div>
                <div>
                    <NavLink to="/negozioonline/carrello">
                    <img className='image-style__kart' src={Shopping} alt="Cart's Icon" title="Torna al Carrello"/>
                    </NavLink>
                </div>
            </div>
            <div className="checkout__info-delevery">
                <p>Sconto di 50% sulle spese di spedizione per tutta la regione dell'Abruzzo.</p>
            </div>
        </div>
    );
}
export default CheckOutBar;
